{
  "attachment_required_hint": "Для этой заявки нужен подтверждающий документ. Прикрепите файл перед отправкой.",
  "reject_code_attachment_required": "Прикрепите подтверждающий документ.",
  "attachment_required_title": "Требовать вложение",
  "attachment_required_caption": "Документ обязателен при превышении любого из порогов. Оставьте порог пустым, чтобы не учитывать его, или укажите 0, чтобы требовать документ всегда.",
  "attachment_required_request_total": "Количество в одной заявке, свыше ({units})",
  "attachment_required_cycle_total": "Количество за цикл, свыше ({units})",
  "attachment_required_threshold_required": "Укажите хотя бы один порог обязательного вложения",
  "attachment_required_threshold_range": "Введите значение от 0 до 999",
  "notice_period_calendar_days": "календарных дней",
  "notice_period_working_days": "рабочих дней",
  "approval_policy_required": "Требуется политика",
  "policy_check_assigned": "Назначена",
  "policy_check_matched": "Применена более приоритетная политика",
  "policy_check_not_effective": "Ещё не действует",
  "policy_check_pending": "Назначится после пересчёта",
  "policy_check_not_matched": "Не подходит",
  "policy_check_rules_count": "{count, plural, one {# правило} few {# правила} many {# правил} other {# правила}}",
  "policy_checks_title": "Почему такая политика",
  "policy_checks_no_policies": "В категории нет политик",
  "policy_checks_none_matched": "Сотрудник не подходит ни под одну политику категории",
  "policy_checks_open_category": "Открыть категорию",
  "policy_checks_title_none": "Почему нет политики",
  "policy_issues_found": "Найдены проблемы с политиками",
  "review_employees": "Просмотреть сотрудников",
  "without_required_approval_only": "Без требуемой политики согласования",
  "without_required_approval_only_description": "Показать только сотрудников, которым требуется политика согласования, но она не назначена",
  "policy_duplicate_caption": "Копия получит те же настройки и текущие правила и встанет последней в категории. Она никого не заберёт, пока вы не поднимете её выше",
  "policy_duplicate_title": "Дублировать политику",
  "without_policy_only": "Без политики",
  "without_policy_only_description": "Показать только сотрудников, у которых хотя бы в одной категории не назначена политика",
  "absence_type": "Тип отсутствия",
  "absence_type_sick_leave": "Больничный",
  "absence_type_vacation": "Отпуск",
  "accrual_action_accrual": "Начисление",
  "accrual_action_adjustment": "Изменение баланса",
  "accrual_action_balance_import": "Импорт баланса",
  "accrual_action_booked": "Забронировано",
  "accrual_action_canceled": "Отменено",
  "accrual_action_carryover": "Перенос",
  "accrual_action_expire": "Срок использования истек",
  "accrual_action_expiration": "Срок использования истек",
  "accrual_action_initial_balance": "Начальный баланс",
  "accrual_action_used": "Использовано",
  "accrual_capped_note": "Достигнут лимит максимального баланса",
  "accrual_at_type_at_end_caption": "Пример: {units} за июль начисляются 31 июля, после отработанного месяца",
  "accrual_at_type_at_end_each": "в конце каждого периода",
  "accrual_at_type_at_end_title": "Конец периода",
  "accrual_at_type_at_start_caption": "Пример: {units} за июль начисляются 1 июля, доступны для использования сразу",
  "accrual_at_type_at_start_each": "в начале каждого периода",
  "accrual_at_type_at_start_title": "Начало периода",
  "accrual_at_type_description": "Выберите, когда начислять {units} баланса отсутствия за период",
  "accrual_at_type_title": "Время начисления отсутствия",
  "accrual_cap_title": "Максимальный баланс",
  "accrual_cap_yes_caption": "Если не включено, баланс будет расти без ограничений",
  "accrual_cap_yes_label": "Максимальный баланс, {units}",
  "accrual_cycles": "Циклы начисления",
  "accrual_cycles_caption": "Определяет, когда начинается новый цикл начисления",
  "accrual_freq_biweekly": "каждые две недели",
  "accrual_freq_daily": "каждый день",
  "accrual_freq_hire_date_monthly": "каждый месяц в годовщину даты начала работы",
  "accrual_freq_hire_date_monthly_annual_proportional": "в год ежемесячно в годовщину даты начала работы",
  "accrual_freq_monthly": "каждый месяц",
  "accrual_freq_monthly_annual_proportional": "в год ежемесячно",
  "accrual_freq_quarterly": "каждый квартал",
  "accrual_freq_semiannual": "дважды в год",
  "accrual_freq_semimonthly": "дважды в месяц",
  "accrual_freq_weekly": "каждую неделю",
  "accrual_freq_yearly": "каждый год",
  "accrual_freq_yearly_hire_date": "каждый год в годовщину даты начала работы",
  "accrual_information": "{amount} начисляется {period}",
  "accrual_summary_added_at_caption": "{amount, plural, one {начисляемого} few {начисляемых} many {начисляемых} other {начисляемых}}",
  "accrual_summary_earn_caption": "Сотрудники накапливают",
  "accrual_summary_plural_leave_days": "{count, plural, one {день} few {дня} many {дней} other {дней}} отсутствия",
  "accrual_summary_plural_leave_hours": "{count, plural, one {час} few {часа} many {часов} other {часов}} отсутствия",
  "accrue": "Начисление",
  "accrue_for": "Будет начислено за {period}",
  "accrue_settings": "Настройки начисления",
  "accrued": "Начислено",
  "accrued_by_now": "Начислено к настоящему моменту в этом периоде",
  "accrued_for": "Начислено за {period}",
  "accrued_total_in_period": "Всего будет начислено в этом периоде",
  "accrues_and_spendings": "Начисления и списания по всем видам отсутствий",
  "action": "Действие",
  "add_milestone": "Добавить этап",
  "add_note": "Добавить заметку",
  "add_note_description": "При необходимости укажите причину отсутствия...",
  "adjustment_deleted": "Начисление удалено",
  "all_balance_changes": "Все изменения балансов",
  "all_timeoff": "Все отсутствия",
  "apply_changes": "Применить изменения",
  "apply_to_all_workdays": "Применить ко всем рабочим дням",
  "apply_to_all_workdays_caption": "Выходные не будут учитываться",
  "apply_changes_from_date": "Применить изменения с {date}",
  "apply_to_current_rules": "Применить к текущим правилам",
  "apply_to_current_rules_caption": "Действует с {date}",
  "affected_period": "Затронутый период {start} — {end}",
  "approved_timeoffs_may_exceed_caption": "Ранее согласованные отсутствия могут привести к превышению лимитов политики",
  "balances_will_be_recalculated_count": "{count, plural, =0{Балансы сотрудников не будут пересчитаны} one{Будет пересчитан баланс # сотрудника} few{Будут пересчитаны балансы # сотрудников} other{Будут пересчитаны балансы # сотрудников}}",
  "changes_will_take_effect_on": "Изменения вступят в силу {date}",
  "choose_effective_date_caption": "Выберите дату в будущем",
  "choose_effective_date_to_apply_changes": "Выберите дату вступления изменений в силу",
  "create_new_rules_from": "Создать новые правила с...",
  "effective_date": "Дата вступления в силу",
  "employees_will_use_these_rules_count": "{count, plural, =0{Никто не будет использовать эти правила} one{# сотрудник будет использовать эти правила} few{# сотрудника будут использовать эти правила} other{# сотрудников будут использовать эти правила}}",
  "existing_balances_will_stay_unchanged": "Текущие балансы останутся без изменений",
  "historical_balances_will_be_recalculated": "Исторические балансы будут пересчитаны",
  "i_understand_historical_changes": "Я понимаю, что исторические балансы и отчёты могут измениться",
  "in_n_days": "{count, plural, =0{Сегодня} one{Через # день} few{Через # дня} other{Через # дней}}",
  "some_balances_may_become_negative": "Некоторые балансы могут стать отрицательными",
  "will_affect_only_future_accruals": "Повлияет только на будущие начисления",
  "approval": "Согласование",
  "approve_request_title": "Запрос на {request_days} — {category_title}",
  "available": "Доступно",
  "available_balance": "Доступный баланс",
  "count_days_available": "{count_days} доступно",
  "count_days_requested": "{count_days} запрошено",
  "available_on_date": "Доступно на {date}: {balance}",
  "away_till": "Отсутствует до {date}",
  "available_balance_on_dates": "На дату начала отсутствия ({date}) доступно: {balance}. После выбранного отсутствия останется: {balance_forecast}",
  "available_today": "Доступно сегодня",
  "awaiting_approval": "Ожидает одобрения {from_count}",
  "balance": "Баланс",
  "balance_after": "Баланс после",
  "balance_as_of": "Остаток на {date}",
  "booked": "Забронировано",
  "booked_time_off": "Забронировано: {time_off_category}",
  "breakdown": "Распределение",
  "carried_from_previous_period": "Перенесено из предыдущего периода",
  "carryover": "Перенос",
  "carryover_date_hire_title": "Дата начала работы",
  "carryover_date_quarter_title": "Первый день квартала",
  "carryover_date_specific_title": "Конкретная дата",
  "carryover_expiration": "Срок действия перенесенных {units}",
  "carryover_expiration_caption": "Срок действия перенесённого отсутствия, если перенос разрешён",
  "carryover_expiration_date_day_title": "День",
  "carryover_expiration_date_month_title": "Месяц",
  "carryover_expiration_date_title": "Выберите, будет ли лимит рассчитываться в днях или месяцах",
  "carryover_expiration_date_week_title": "Неделя",
  "carryover_expiration_date_year_title": "Год",
  "carryover_expiration_no_caption": "Перенесенные {units} доступны до их использования",
  "carryover_expiration_no_title": "Сохранять {units} без ограничения срока",
  "carryover_expiration_yes_caption": "Перенесенные {units} нужно использовать до указанного срока",
  "carryover_expiration_yes_title": "Установить срок использования {units}",
  "carryover_expire_date_type": "Измерять в днях или месяцах",
  "carryover_second_date_title": "Вторая дата",
  "category": "Категория",
  "category_delete_caption": "Если вы удалите эту категорию, начисления, сделанные в соответствии с ней, не будут затронуты",
  "category_delete_title": "Удалить эту категорию",
  "category_type_accrues_time_description": "Сотрудники накапливают дни отсутствия по графику или заданному балансу",
  "category_type_accrues_time_title": "Накопительный",
  "category_type_description": "Накапливать {units} или использовать без баланса",
  "category_type_flexible_description": "Без учета баланса, но требует одобрения и фиксации отсутствия",
  "category_type_flexible_title": "Гибкий (без ограничений)",
  "category_type_manual_description": "Особые правила без автоматического начисления дней",
  "category_type_manual_title": "Ручной",
  "category_type_title": "Тип категории",
  "change_style": "Изменить стиль",
  "choose_category": "Выберите категорию",
  "choose_period": "Выберите период",
  "choose_period_from": "Выберите период с",
  "choose_period_to": "Выберите период по",
  "no_policy": "Без политики",
  "policies_order_confirm_title": "Подтвердите новый порядок",
  "policies_order_hint": "Чем выше политика, тем выше её приоритет. Сотрудник получает политику с наивысшим приоритетом, под правила которой попадает",
  "policies_order_no_transitions": "Никто из сотрудников не перейдёт в другую политику",
  "policies_order_unsaved_changes": "Если вы сейчас измените сортировку, несохранённые изменения на этой странице будут утеряны",
  "policies_manage_priority": "Изменить приоритет",
  "policies_priority_caption": "Перетащите, чтобы изменить приоритет",
  "policies_priority_title": "Приоритет политик",
  "policies_order_review": "Проверить изменения...",
  "policy_assign_taken_by_upper_count": "{count, plural, other{из них # уже в политиках с более высоким приоритетом}}",
  "policy_fallback_caption": "Запасная: для всех, кто не попал в политики с более высоким приоритетом",
  "policy_no_employees": "Нет сотрудников",
  "policy_taken_by_upper_hint": "{count, plural, one{# сотрудник подходит под эту политику, но получает политику с более высоким приоритетом} few{# сотрудника подходят под эту политику, но получают политику с более высоким приоритетом} many{# сотрудников подходят под эту политику, но получают политику с более высоким приоритетом} other{# сотрудника подходят под эту политику, но получают политику с более высоким приоритетом}}",
  "policy_transition_count": "{count, plural, one{# сотрудник перейдёт из {from} в {to}} few{# сотрудника перейдут из {from} в {to}} other{# сотрудников перейдут из {from} в {to}}}",
  "configure_policies_title": "Настройка политик",
  "configure_title": "Настройка параметров отсутствия",
  "contact_manager_to_check_approval_policy_settings": "Обратитесь к руководителю, чтобы проверить настройки политик согласования",
  "count_days_types_calendar_days_description": "Учет всех дней периода, включая выходные и праздники",
  "count_days_types_description": "Укажите, какие дни учитывать при отсутствии: все календарные или только рабочие. Это влияет на подсчет выходных и праздников",
  "count_days_types_title": "Учёт дней",
  "count_days_types_working_days_description": "Учет только рабочих дней, без выходных и праздников",
  "day_amount_type_description": "Выберите, сколько списывает один рабочий день заявки при учёте в днях",
  "day_amount_type_full_day_title": "Целый день",
  "day_amount_type_full_day_description": "Любой рабочий день стоит целый день независимо от графика работы",
  "day_amount_type_title": "Цена дня",
  "day_amount_type_work_pattern_share_title": "По графику работы",
  "day_amount_type_work_pattern_share_description": "День стоит свою долю от самого длинного дня графика — на графике 8/8/8/8/4 пятница списывает полдня",
  "fte_proration_title": "Начислять пропорционально ставке (FTE)",
  "fte_proration_caption": "Сотрудники на неполной занятости начисляют пропорционально своей ставке (FTE). Действует с даты этой версии политики и не пересчитывает прошлые начисления",
  "create_new": "Создать новую категорию",
  "create_new_policy_description": "Настройка правил расчета и использования отсутствия",
  "create_new_policy_title": "Создать новую политику",
  "create_new_timeoff_request": "Новый запрос",
  "create_new_timeoff_request_description": "Создать новый запрос",
  "created": "Создано",
  "custom_amount": "Произвольное значение",
  "custom_amount_caption": "И массовое применение",
  "customize_breakdown": "Настроить распределение",
  "day": "день",
  "days": "Дни",
  "days_genitive": "Дней",
  "days_prepositional": "Днях",
  "decrease_balance": "Списать",
  "delete_adjustment_confirm": "Вы уверены, что хотите удалить это начисление?",
  "delete_adjustment_confirm_description": "Это действие нельзя будет отменить",
  "dont_forget": "Напоминаем",
  "earnings": "Накопления",
  "edit_balance": "Редактировать баланс",
  "edit_policy_title": "Изменить политику",
  "edit_timeoff": "Редактировать отсутствие",
  "edit_timeoff_request": "Редактировать запрос",
  "edit_timeoff_request_description": "Редактировать запрос",
  "edit_title": "Редактирование категории отсутствия",
  "employee_requests": "Запрашивает",
  "enter_amount_in_units": "Введите значение в {units}",
  "expiration_date": "Действует до",
  "full_day": "Полный день",
  "half_day": "Половина дня",
  "history_of_category": "История {category_name}",
  "hour": "час",
  "hours": "Часы",
  "hours_genitive": "Часов",
  "hours_prepositional": "Часах",
  "in_units": "за",
  "increase_balance": "Начислить",
  "insufficient_units_for_request": "Недостаточно {units} для запроса",
  "is_public_description": "Отображать этот тип отсутствия в общих календарях и профилях",
  "is_public_title": "Публичный доступ",
  "leave_earnings": "Начисление отсутствия",
  "leave_type": "Тип отсутствия",
  "leave_type_description": "Укажите, является ли это обычным отсутствием или отсутствием по уходу за ребенком (декретный, отцовский)",
  "leave_type_parental": "Отсутствие по уходу за ребенком",
  "leave_type_regular": "Обычное отсутствие",
  "leave_types": "Типы отсутствий",
  "limits_negative_balance_allowance_caption": "Разрешить оформлять отсутствие сверх накопленных {units}",
  "limits_negative_balance_allowance_title": "Разрешить отрицательный баланс",
  "max_amount": "Максимальное количество",
  "milestone_accrual_date_type_biweekly": "Каждые 2 недели",
  "milestone_accrual_date_type_daily": "Ежедневно",
  "milestone_accrual_date_type_hire_date": "В годовщину работы",
  "milestone_accrual_date_type_hire_date_monthly": "Каждый месяц в дату начала работы",
  "milestone_accrual_date_type_hire_date_monthly_annual_proportional": "Каждый год, начисления каждый месяц в дату начала работы",
  "milestone_accrual_date_type_monthly": "Каждый месяц",
  "milestone_accrual_date_type_monthly_annual_proportional": "Каждый год, начисления каждый месяц",
  "milestone_accrual_date_type_quarterly": "Квартально",
  "milestone_accrual_date_type_semiannual": "2 раза в год",
  "milestone_accrual_date_type_semimonthly": "2 раза в месяц",
  "milestone_accrual_date_type_weekly": "Каждую неделю",
  "milestone_accrual_date_type_yearly": "Каждый год 1 раз",
  "milestone_carryover_none_caption": "Неиспользованный баланс отсутствия сгорает в конце года/годовщины",
  "milestone_carryover_none_title": "Без переноса",
  "milestone_carryover_settings_caption": "В конце цикла",
  "milestone_carryover_settings_description": "Что происходит с неиспользованным балансом отсутствия?",
  "milestone_carryover_unlimited_caption": "Весь неиспользованный баланс отсутствия переносится (с учетом лимитов)",
  "milestone_carryover_unlimited_title": "Сохранить весь остаток",
  "milestone_carryover_up_to_caption": "Сохранить определенное количество дней для следующего года",
  "milestone_carryover_up_to_title": "Ограниченный перенос",
  "milestone_delete_caption": "Удаление этапа не затронет уже начисленный баланс отсутствия. Прекратятся только будущие начисления",
  "milestone_delete_title": "Удалить этап начисления",
  "milestone_edit": "Изменить этап",
  "milestone_list_caption_on_date": "{date}",
  "milestone_list_caption_on_day": "{day}-го числа",
  "milestone_list_caption_on_two_dates": "{date1} и {date2}",
  "milestone_list_caption_on_two_days": "{day1}-го и {day2}-го числа",
  "milestone_list_title": "Начиная с {amount}-{date_type, select, day{го дня} week{й недели} month{го месяца} year{го года} other{}}",
  "milestone_new": "Новый этап",
  "milestone_start": "Дата начала",
  "milestone_start_amount_title": "С даты начала работы",
  "milestone_start_balance_caption": "Если не включено, начальный баланс будет равен 0",
  "milestone_start_balance_lable": "Баланс на начало этапа, {units}",
  "milestone_start_balance_title": "Начальный баланс",
  "milestone_start_description": "Выберите, когда сотрудники начинают накапливать дни отсутствия",
  "milestone_start_text_from_hire_date": "от даты начала работы",
  "milestone_start_text_number": "номер",
  "milestone_start_text_starts_in": "Этап начнется в",
  "milestone_starts_from_hire_date": "Отсчёт от даты начала работы",
  "milestone_starts_from_hire_date_caption": "Отключите, если хотите выбрать другой период",
  "milestone_transfer_type_description": "Выберите, когда начинать применять новые условия по стажу",
  "milestone_transfer_type_end_period_caption": "Новые условия применяются с начала следующего периода начисления",
  "milestone_transfer_type_end_period_title": "С нового периода",
  "milestone_transfer_type_immediately_caption": "Новые условия применяются сразу при достижении стажа",
  "milestone_transfer_type_immediately_title": "Сразу при наступлении",
  "milestone_transfer_type_title": "Когда применять новые условия",
  "milestones": "Этапы начисления",
  "milestones_description": "Этапы позволяют изменять правила начисления со временем",
  "min_amount": "Минимальное количество",
  "minimum_daily_amount_caption": "Минимальная длительность запроса на отсутствие (целый {unit} или часть)",
  "minimum_daily_amount_title": "Минимальная дневная норма",
  "minimum_fraction_is": "Минимальный интервал",
  "modified": "Изменено",
  "modified_breakdown": "Распределение изменено",
  "negative_balance_in_cycle_allowed_caption": "Разрешить отрицательный баланс в только рамках текущего цикла начисления",
  "negative_balance_in_cycle_allowed_title": "Отрицательный баланс только в цикле",
  "new_policy_title": "Новая политика",
  "no_requests_created": "Запросов на отсутствие пока нет",
  "no_requests_created_description": "Здесь будут отображаться все ваши запросы на отсутствие",
  "not_available": "Недоступно",
  "notice_period_caption": "Срок подачи заявления на отсутствие",
  "notice_period_title": "Мин. и макс. срок уведомления",
  "notification_approval_request_title": "Ожидает одобрения запроса на {category}",
  "notification_settings_time_off_caption": "Когда требуется согласование или ответ на запрос",
  "overlap_requests_allowed_caption": "Разрешить оформлять отсутствие на даты, которые пересекаются с другими запросами",
  "overlap_requests_allowed_title": "Пересечения по датам",
  "paid_type_description": "Выберите способ расчета оплаты на время отсутствия",
  "paid_type_not_working_paid_description": "Сотрудник не работает, но получает оплату (например, отсутствие или праздники)",
  "paid_type_not_working_paid_title": "Нерабочие, оплачиваемые",
  "paid_type_not_working_unpaid_description": "Отсутствие без сохранения зарплаты (личные причины, отсутствие за свой счет)",
  "paid_type_not_working_unpaid_title": "Нерабочие, неоплачиваемые",
  "paid_type_title": "Тип оплаты",
  "paid_type_working_paid_description": "Сотрудник получает обычную зарплату во время отсутствия (больничный)",
  "paid_type_working_paid_title": "Рабочие, оплачиваемые",
  "past_requests_allowed_caption": "Разрешить оформлять отсутствие на уже прошедшие даты",
  "past_requests_allowed_title": "Отсутствие задним числом",
  "period_track_type_title": "Единицы измерения",
  "policy_report": "Текущие политики",
  "probation_requests_restricted_caption": "Запретить оформлять отсутствие, пока сотрудник на испытательном сроке",
  "probation_requests_restricted_title": "Запрет на испытательном сроке",
  "reject_code_asked_date_from_less_then_min_notice_period": "Запрошенная дата начала раньше минимального периода уведомления.",
  "reject_code_asked_date_from_less_then_today": "Запрошенная дата начала раньше сегодняшней даты.",
  "reject_code_asked_date_from_more_then_max_notice_period": "Запрошенная дата начала выходит за пределы максимального периода уведомления.",
  "reject_code_asked_less_then_min_daily_amount": "Запрошенная сумма меньше минимально допустимого дневного значения.",
  "reject_code_asked_less_then_min_request_total": "Общая запрошенная сумма ниже минимально допустимого значения.",
  "reject_code_asked_more_then_max_request_total": "Общая запрошенная сумма превышает максимально допустимое значение.",
  "reject_code_cannot_create_overlapped_time_off_requests": "Невозможно создать запросы на отсутствие, которые пересекаются по времени",
  "reject_code_cannot_create_time_off_requests_in_probation": "Отсутствие недоступно на испытательном сроке",
  "reject_code_invalid_request": "Запрос недействителен. Пожалуйста, проверьте отправленные данные.",
  "reject_code_no_approval_policy": "С этим запросом не связана политика утверждения.",
  "reject_code_no_confirmation_employees": "Нет сотрудников, требующих подтверждения для этого действия.",
  "reject_code_no_time_off_policy": "У выбранной категории отсутствия нет политики в настройках. Обратитесь к администратору",
  "reject_code_not_enough_days": "Недостаточно дней для выполнения этого запроса.",
  "reject_code_not_enough_hours": "Недостаточно часов для выполнения этого запроса.",
  "reject_code_time_off_category_not_found": "Указанная категория отгула не найдена.",
  "category_request": "Запрос на {category}",
  "request_amount_caption": "Ограничения на продолжительность одного отсутствия",
  "request_amount_title": "Мин. и макс. продолжительность",
  "request_time_off": "Запросить {category_name}",
  "request_timeoff": "Запросить отсутствие",
  "require_confirmation": "Подтверждение заявок",
  "require_confirmation_description": "Требуется ли одобрение заявок на отсутствие",
  "require_confirmation_no_caption": "Нет, подтверждение не требуется",
  "require_confirmation_no_description": "Заявки одобряются автоматически при создании",
  "require_confirmation_yes_caption": "Да, требуется подтверждение",
  "require_confirmation_yes_description": "Руководитель должен одобрить каждую заявку",
  "save_final_approved_caption": "Ваш календарь обновлен, и ваша команда уведомлена",
  "save_final_approved_title": "Отсутствие утверждено!",
  "save_final_await_caption": "Мы уведомили утверждающих. Вы получите ответ, как только они рассмотрят запрос",
  "save_final_await_title": "Ваш запрос отправлен!",
  "see_requests": "Посмотреть запросы",
  "settings_description": "Настройте политики отсутствий и их учет",
  "settings_title": "Отсутствия и отгулы",
  "spendings": "Списания",
  "start_balance_type_description": "Сколько дней отсутствия получит новый сотрудник при устройстве",
  "start_balance_type_full_caption": "Сотрудник получает весь баланс отсутствия ({units}) сразу, независимо от даты начала работы",
  "start_balance_type_full_title": "Полное начисление",
  "start_balance_type_proportional_caption": "{units_cap} рассчитываются от даты начала работы. Пример: осталось 6 месяцев = половина баланса отсутствия",
  "start_balance_type_proportional_title": "Пропорциональное начисление",
  "start_balance_type_title": "Первое начисление",
  "termination_accrual_type_title": "При увольнении",
  "termination_accrual_type_description": "Что начислить в дату увольнения за неполный период",
  "termination_accrual_type_proportional_title": "Пропорционально",
  "termination_accrual_type_proportional_caption": "Начисляется доля за отработанную часть периода",
  "termination_accrual_type_no_partial_title": "Не начислять за неполный период",
  "termination_accrual_type_no_partial_caption": "За неполный период в дату увольнения ничего не начисляется",
  "time_off": "Отпуска",
  "time_off_calendar": "Календарь отсутствий",
  "filter_employee_subordinates": "Подчинённые сотрудника",
  "time_off_delete_title": "Удалить запись «{time_off_type}»",
  "time_off_description": "Управление заявками на отсутствие, больничными и процессами согласования",
  "time_off_history_for": "История отсутствий для {employee}",
  "title": "Управление отсутствиями",
  "total_units": "Количество {units}",
  "used_amount": "Использованное количество",
  "transfer_unused_balance": "Перенос неиспользованного баланса на следующий период",
  "units_accrued": "<b>{units}</b> начислено",
  "units_to_accrue": "<b>{units}</b> начислится",
  "units_booked": "<b>{units}</b> забронировано",
  "units_expired": "<b>{units}</b> сгорело",
  "units_to_expire": "<b>{units}</b> сгорит",
  "units_spent": "<b>{units}</b> потрачено",
  "used": "Использовано",
  "used_time_off": "Использовано: {time_off_category}",
  "before_date": "До {date}",
  "changes_timeline": "История изменений",
  "current_rules": "Текущие правила",
  "current_rules_since": "Текущие правила с {date}",
  "change_effective_date": "Изменить дату вступления в силу",
  "edit_rules": "Изменить правила",
  "hide_changes": "Скрыть изменения",
  "initial_rules": "Начальные правила",
  "since_date": "С {date}",
  "vacancies_sick": "Отсутствия, больничные и другое",
  "view_all_history": "Посмотреть всю историю",
  "view_breakdown": "Посмотреть распределение",
  "view_changes": "Посмотреть изменения",
  "~": "~",
  "action_tag_carryover": "Перенесено",
  "action_tag_adjusted": "Изменено",
  "action_tag_burned": "Сгорело",
  "adjusted_by": "Изменено: {name}",
  "all_requests_history": "История всех отсутствий",
  "balance_change": "Изменение"
}
